// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FtKf","fullView":"styles_fullView__S2rBp"};